var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profit-loss"},[_c('div',{staticClass:"expire-date"},[_vm._v("\n    "+_vm._s(_vm.$t('expire-date'))+"："+_vm._s(_vm.expireDate)+"\n  ")]),_vm._v(" "),_c('svg',{ref:"svg",attrs:{"id":"profitLoss","width":"240","height":"120","preserveAspectRatio":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }